import Reveal, { Eyebrow } from "./Reveal";
import { CalendarCheck, FlaskConical, Rocket } from "lucide-react";

const STEPS = [
  { icon: CalendarCheck, title: "Book a demo", body: "See the agents on real flows for your use case." },
  { icon: FlaskConical, title: "Pilot on one use case", body: "One agent, one list, measured against your current results." },
  { icon: Rocket, title: "Roll out", body: "Add agents and use cases once the pilot proves itself." },
];

const WhoItsFor = () => (
  <section data-testid="get-started-section" className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow>Who it's for</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
              Built for teams that live on the phone.
            </h2>
            <p className="text-zinc-600 mt-6 leading-relaxed max-w-md">
              Lenders and collections teams, clinics, garages and service businesses, pharmacies,
              restaurants. If your team spends its days dialling lists where most numbers never
              connect — or missing calls because nobody is free to answer — Voicxent does the
              dialling and the first conversation, and hands your people the cases that need them.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <Eyebrow>How to get started</Eyebrow>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-8">
            {STEPS.map((s, i) => (
              <Reveal key={s.title} delay={0.12 + i * 0.08}>
                <div
                  data-testid={`get-started-step-${i + 1}`}
                  className="h-full bg-white border border-zinc-200 rounded-2xl p-6 hover:border-[#09090B] hover:-translate-y-1 transition-all duration-500"
                >
                  <s.icon size={24} className="text-[#2563EB]" />
                  <p className="font-mono2 text-[10px] uppercase tracking-widest text-zinc-400 mt-5">Step {i + 1}</p>
                  <h3 className="font-display font-bold text-lg mt-1.5">{s.title}</h3>
                  <p className="text-zinc-600 text-sm mt-2 leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WhoItsFor;
